
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { QuoteAddress, StoreLocator } from '@/store/models';
import checkout from '@/store/modules/checkout';
import storelocator from '@/store/modules/storelocator';

@Component
export default class AddressSummary extends Vue {
    @Prop() private address!: QuoteAddress;
    @Prop() private isShipping!: boolean;

    get isStorePickup(): boolean {
        return checkout.isStorePickup;
    }

    get isRegionFulfilled(): boolean {
        if (this.address.region_id || (this.address.region && this.address.region !== 'n/a')) {
            return true;
        }
        return false;
    }

    get selectedStorePickup(): StoreLocator {
        return storelocator.storeById(storelocator.selectedStoreId);
    }

    private streetNumber(address: QuoteAddress): string {
        const custom_attributes: [] = address.custom_attributes;
        const street: any = custom_attributes.filter(
            (attribute: any) => attribute.attribute_code === 'tdy_street_number');
        return street[0].value;
    }

    get extraAddress(): string {
      return this.address.custom_attributes.find((att: any) => att.attribute_code === 'tdy_extra_address').value;
    }

}
